


































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {StillShot} from '@/store/shots'
import {getUUID} from '@/store/store-utils'
import {upload} from '@/asset'
import Params from '@/components/Params.vue'
import {shotStore} from "@/store";

@Component({
  components: {
    Params
  }
})
export default class StillShotEditor extends Vue {
  @Prop() shot!: StillShot
  loading = false
  shotImageUrl = ''

  mounted() {
    this.setupShotImageUrl()
  }

  updated() {
    this.setupShotImageUrl()
  }

  pickFile() {
    let elt = this.$refs.files
    if (elt instanceof Array)
      elt = elt[0]              // choose first one if they picked more than one
    if (elt instanceof HTMLElement)
      elt.click()
    else
      this.$log.error('Picked invalid object type', elt)
  }

  async onFilePicked(e: InputEvent) {
    if (!e.target)
      return
    const files = (e.target as HTMLInputElement).files
    if (!files)
      return
    for (const file of files) {
      if (file !== undefined && file.name.lastIndexOf('.') > 0) {
        this.loading = true
        this.$log.debug(`Uploading`, file)
        const assetId = getUUID('asset')
        const progressCb = (progress: number) => {
          this.$log.info(`Upload of ${file.name} is ${progress}% done`)
        }
        try {
          const {downloadURL, storagePath} = await upload(assetId, 'still', file, 'jpg',
                                                          progressCb)
          this.$toast(`${file.name} uploaded!`)
          this.$emit('update-shot-image', downloadURL)
        } catch (err) {
          this.$toast.error(`Error uploading ${file.name}: ${err}`)
        } finally {
          this.loading = false
        }
      }
    }
  }

  saveImageUrl(imageUrl: string) {
    this.$log.info(`Update image URL: ${imageUrl}`)
    if (this.shot.imageFile !== imageUrl)
      shotStore.updateShotImageUrl({shot: this.shot, imageUrl})
  }

  private setupShotImageUrl() {
    const fbStorageRe = /^https:\/\/firebasestorage\.googleapis\.com\//
    if (this.shot.imageFile && this.shot.imageFile !== '') {
      if (fbStorageRe.test(this.shot.imageFile))
        this.shotImageUrl = ''
      else
        this.shotImageUrl = this.shot.imageFile
    }
  }
}

